import { computed } from 'vue'

export function useIntlState() {
  const isInternational = computed(() => {
    return (
      window.location.hostname.endsWith('mirgovorit.com') ||
      !!sessionStorage.getItem('forceDotCom') ||
      !!localStorage.getItem('forceDotCom')
    )
  })

  return { isInternational }
}
